import './assets/main.css'

import { createRoot } from 'react-dom/client'
import App from './App'
import { initSuperTokens } from './config/supertokens'

// Initialize SuperTokens
try {
  initSuperTokens()
} catch (error) {
  console.error('Failed to initialize SuperTokens:', error)
}

// StrictMode disabled in dev so the LiveKit hook doesn't double-mount
// and create two learner participants in the same room (which confuses
// the agent's audio subscription). Re-enable for production builds.
createRoot(document.getElementById('root')!).render(<App />)
